import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const MiniMap = ({ geo }) => {
    let coords = null;
    if (typeof geo === 'string') {
        coords = geo.split(',').map(s => parseFloat(s.trim()));
    } else if (Array.isArray(geo) && geo.length === 2) {
        coords = geo;
    }
    if (!coords || coords.length !== 2 || coords.some(isNaN)) return null;

    // leaflet marker icon fix for webpack
    const markerIcon = new L.Icon({
        iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

    // Границы Кыргызстана
    const kyrgyzstanBounds = [
        [39.172, 69.276], // Southwest
        [43.238, 80.283]  // Northeast
    ];

    return (
        <div style={{ width: '200px', height: '150px', marginTop: '8px', borderRadius: '4px', overflow: 'hidden', border: '1px solid #ddd' }}>
            <MapContainer 
                center={coords} 
                zoom={13} 
                minZoom={7}
                maxBounds={kyrgyzstanBounds}
                maxBoundsViscosity={1.0}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={false}
                dragging={true}
                zoomControl={false}
                attributionControl={false}
            >
                <TileLayer 
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    attribution="&copy; Esri"
                    maxZoom={19}
                />
                <TileLayer 
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution=""
                    maxZoom={19}
                    opacity={0.65}
                />
                <Marker position={coords} icon={markerIcon} />
            </MapContainer>
        </div>
    );
};

export default MiniMap;